import { ApexOptions } from "apexcharts";

//charts
export var earningChart: ApexOptions = {
    series: [{
        name: 'Revenue',
        data: [92, 64, 43, 80, 58, 92, 46, 76, 80]
    }, {
        name: 'Revenue',
        data: [20, 48, 69, 32, 54, 20, 66, 36, 32],
    },
    ],
    chart: {
        type: 'bar',
        offsetY: 30,
        toolbar: {
            show: false
        },
        height: 100,
        stacked: true,
    },
    states: {
        hover: {
            filter: {
                type: 'darken',
            }
        }
    },
    plotOptions: {
        bar: {
            horizontal: false,
            borderRadius: 3,
            columnWidth: '55%',
        }
    },
    dataLabels: {
        enabled: false
    },
    grid: {
        yaxis: {
            lines: {
                show: false
            }
        },
    },
    xaxis: {
        labels: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        show: false,
    },
    fill: {
        opacity: 1,
        colors: ['#6f5a99', '#dedffc']
    },
    legend: {
        show: false
    },
    tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, }) {
            return '<div class="apex-tooltip p-2">' + '<span>' + '<span class="bg-primary">' + '</span>' + 'Revenue' + '<h3>' + '$' + series[seriesIndex][dataPointIndex] + '<h3/>' + '</span>' + '</div>';
        },
    },
    responsive: [
        {
            breakpoint: 768,
            options: {
                chart: {
                    offsetY: 45,
                }
            }
        },
    ],
};

export var salesChart: ApexOptions = {
    series: [{
        name: "Sales",
        data: [15, 25, 20, 35, 16, 18, 10, 22, 18, 25, 17],
    }],
    chart: {
        type: 'area',
        height: 120,
        offsetY: 50,
        zoom: {
            enabled: false
        },
        toolbar: {
            show: false,
        },
        dropShadow: {
            enabled: true,
            top: 5,
            left: 0,
            blur: 2,
            color: '#e24175',
            opacity: 0.2,
        },
    },
    colors: ['#e24175'],
    fill: {
        type: "gradient",
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.6,
            opacityTo: 0.2,
            stops: [0, 100, 100]
        }
    },
    dataLabels: {
        enabled: false
    },
    grid: {
        show: false,
    },
    xaxis: {
        labels: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        show: false,
    },
    stroke: {
        curve: 'smooth',
        width: 2,
    },
    tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, }) {
            return '<div class="apex-tooltip p-2">' + '<span>' + '<span class="bg-primary">' + '</span>' + 'Sales' + '<h3>' + '$' + series[seriesIndex][dataPointIndex] + '<h3/>' + '</span>' + '</div>';
        },
    },
};

export var totalCustomerChart: ApexOptions = {
    series: [{
        name: "Desktops",
        data: [10, 35, 15, 78, 40, 60, 12, 60],
    }],
    chart: {
        type: 'area',
        height: 120,
        offsetY: 50,
        zoom: {
            enabled: false
        },
        toolbar: {
            show: false,
        },
        dropShadow: {
            enabled: true,
            top: 5,
            left: 0,
            blur: 2,
            color: '#1669A3',
            opacity: 0.2,
        },
    },
    colors: ['#1669A3'],
    fill: {
        type: "gradient",
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.6,
            opacityTo: 0.2,
            stops: [0, 100, 100]
        }
    },
    dataLabels: {
        enabled: false
    },
    grid: {
        show: false,
    },
    xaxis: {
        labels: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        show: false,
    },
    stroke: {
        curve: 'straight',
        width: 2,
    },
    tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, }) {
            return '<div class="apex-tooltip p-2">' + '<span>' + '<span class="bg-primary">' + '</span>' + 'customer' + '<h3>' + '$' + series[seriesIndex][dataPointIndex] + '<h3/>' + '</span>' + '</div>';
        },
    },
};

export var totalProductChart: ApexOptions = {
    series: [80],
    chart: {
        type: 'radialBar',
        offsetY: 50,
        height: 180,
        sparkline: {
            enabled: false,
        },
    },
    plotOptions: {
        radialBar: {
            startAngle: -90,
            endAngle: 90,
            hollow: {
                size: '55%',
            },
            track: {
                background: "#ffebe1",
                strokeWidth: '120%',
            },
            dataLabels: {
                name: {
                    show: false,
                    color: 'var(--title)',
                    fontSize: '17px',
                },
                value: {
                    offsetY: -2,
                    fontSize: '22px',
                }
            }
        }
    },
    xaxis: {
    },
    stroke: {
        lineCap: 'round'
    },
    colors: ['#D77748'],
    responsive: [
        {
            breakpoint: 1800,
            options: {
                chart: {
                    height: 160,
                    offsetY: 60,
                }
            }
        },
        {
            breakpoint: 768,
            options: {
                chart: {
                    offsetY: 30,
                }
            }
        },
    ],
};

export var recentChart: ApexOptions = {
    series: [
        {
            type: "line",
            data: [150, 470, 250, 380, 100, 480, 420],
        },
        {
            type: "area",
            data: [300, 180, 420, 250, 320, 180, 400],
        },
    ],
    chart: {
        height: 360,
        type: "area",
        toolbar: {
            show: false,
        },
        dropShadow: {
            enabled: true,
            left: 8,
            blur: 0,
            color: '#6f5a99',
            opacity: 0.1,
        },
    },
    dataLabels: {
        enabled: false,
    },
    stroke: {
        curve: "smooth",
        width: [5, 0],
        colors: ['#6f5a99', '#6f5a99'],
    },

    grid: {
        borderColor: "#3f3a591a",
    },

    fill: {
        type: "solid",
        opacity: [1, 0.2],
    },
    tooltip: {
        marker: {
            show: false,
        },
        fixed: {
            enabled: false,
            position: "bottomRight",
            offsetX: 0,
            offsetY: 0,
        },
        shared: true,
        intersect: false,
        y: {
            formatter: function (y) {
                if (typeof y !== "undefined") {
                    return y.toFixed(0) + " k";
                }
                return y;
            },
        },
    },
    xaxis: {
        categories: ["Jan", "Feb", "Mar", "April", "May", "June", "July"],
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
        crosshairs: {
            show: true,
            width: 50,
            position: "back",
            opacity: 0.2,
            stroke: {
                color: '#6f5a99',
                width: 0,
                dashArray: 0,
            },

            fill: {
                type: "solid",
                color: '#6f5a99',
            },
        },
        tooltip: {
            enabled: false,
        },
    },
    legend: {
        show: false,
    },
    responsive: [
        {
            breakpoint: 575,
            options: {
                chart: {
                    height: 280,
                },
            },
        },

        {
            breakpoint: 400,
            options: {
                chart: {
                    height: 230,
                },
            },
        },
    ],
    colors: ['#6f5a99', "#99cef1"],
};

export var categoriesChart: ApexOptions = {
    series: [50, 30, 20],
    chart: {
        type: 'donut',
        height: 410,
    },
    plotOptions: {
        pie: {
            expandOnClick: false,
            startAngle: -90,
            endAngle: 90,
            offsetY: 10,
            donut: {
                size: "75%",
                labels: {
                    show: true,
                    name: {
                        offsetY: -10,
                    },
                    value: {
                        offsetY: -50,
                    },
                    total: {
                        show: true,
                        fontSize: "18px",
                        fontFamily: "'Jost', sans-serif",
                        fontWeight: 500,
                        label: "Product Sales",
                        color: "#959595",
                        formatter: (w) => "14,937",
                    },
                },
            },
            customScale: 1,
            offsetX: 0,
        },
    },
    grid: {
        padding: {
            bottom: -120
        }
    },
    colors: ['#6f5a99', '#e24175', "#D77748"],
    responsive: [
        {
            breakpoint: 1601,
            options: {
                chart: {
                    height: 340,
                },
            },
        },
        {
            breakpoint: 420,
            options: {
                chart: {
                    height: 280,
                },
            },
        },
    ],
    legend: {
        show: false,
    },
    dataLabels: {
        enabled: false,
    },
};

export var totalProfitChart: ApexOptions = {
    series: [{
        name: 'Total Profit',
        type: 'column',
        data: [20, 20, 40, 30, 60, 50, 35, 25, 50, 45, 55, 60, 20, 45, 20, 20]
    },
    {
        name: 'Total Profit',
        type: 'area',
        data: [50, 50, 45, 55, 50, 60, 56, 58, 50, 65, 60, 50, 60, 52, 55, 55]
    }
    ],
    chart: {
        height: 280,
        type: "bar",
        offsetY: 15,
        toolbar: {
            show: false,
        },
    },
    plotOptions: {
        bar: {
            horizontal: false,
            columnWidth: "15px",
        },
    },
    fill: {
        opacity: [1, 0.05],
        gradient: {
            type: "vertical",
            opacityFrom: 0.5,
            opacityTo: 0.1,
            stops: [100, 100, 100]
        }
    },
    stroke: {
        show: false,
    },
    legend: {
        show: false,
    },
    grid: {
        show: false,
        padding: {
            top: -35,
            right: -45,
            bottom: -20,
            left: -35
        },
    },
    dataLabels: {
        enabled: false
    },
    xaxis: {
        axisBorder: {
            show: false
        },
        labels: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        labels: {
            show: false,
        }
    },
    colors: ['#6f5a99'],
    responsive: [
        {
            breakpoint: 1200,
            options: {
                chart: {
                    height: 260,
                },
            },
        },
    ],
};

//datas
export const totalSalesData = [
    {
        id: 1,
        divClass: '',
        icon: 'Revenue',
        rate: '$25,456',
        title: 'Total Revenue',
        arrowIcon: 'arrow-chart-up',
        percent: '+45',
        fontColor: 'success',
        chartClass: 'earning-chart',
        chart: {
            ...earningChart,
            series: earningChart.series,
            type: earningChart.chart?.type,
            height: earningChart.chart?.height
        },
    },
    {
        id: 2,
        divClass: 'up-sales',
        icon: 'Sales',
        rate: '20k USD',
        title: 'Total Sales',
        arrowIcon: 'arrow-chart',
        percent: '-10',
        fontColor: 'danger',
        chartClass: 'sales-chart',
        chart: {
            ...salesChart,
            series: salesChart.series,
            type: salesChart.chart?.type,
            height: salesChart.chart?.height
        },
    },
    {
        id: 3,
        divClass: 'total-customer',
        icon: 'Customer',
        rate: '50,863',
        title: 'All Customer',
        arrowIcon: 'arrow-chart',
        percent: '-15',
        fontColor: 'danger',
        chartClass: 'customer-chart',
        chart: {
            ...totalCustomerChart,
            series: totalCustomerChart.series,
            type: totalCustomerChart.chart?.type,
            height: totalCustomerChart.chart?.height
        },
    },
    {
        id: 4,
        divClass: 'total-product',
        icon: 'Product',
        rate: '56,491',
        title: 'Total Product',
        arrowIcon: 'arrow-chart-up',
        percent: '+30',
        fontColor: 'success',
        chartClass: 'total-product-chart',
        chart: {
            ...totalProductChart,
            series: totalProductChart.series,
            type: totalProductChart.chart?.type,
            height: totalProductChart.chart?.height
        },
    }
]

export const grossSalesData = [
    {
        id: 1,
        image: '01.png',
        name: 'Anna Catmire',
        date: '10 August',
        product: 'Watch',
        flag: 'gb',
        total: '56,764',
    },
    {
        id: 2,
        image: '02.png',
        name: 'Laura Dason',
        date: '15 Sept',
        product: 'Electronics',
        flag: 'us',
        total: '56,845',
    },
    {
        id: 3,
        image: '03.png',
        name: 'Rachel Gree',
        date: '10 March',
        product: 'Shoes',
        flag: 'za',
        total: '96,658',
    },
    {
        id: 4,
        image: '04.png',
        name: 'Polly Meery',
        date: '25 May',
        product: 'Clothes',
        flag: 'at',
        total: '65,874',
    }
]

export const categoriesList = [
    {
        id: 1,
        color: 'primary',
        percent: 50,
        title: 'Groceries'
    },
    {
        id: 2,
        color: 'secondary',
        percent: 30,
        title: 'Cloths Trends'
    },
    {
        id: 3,
        color: 'warning',
        percent: 20,
        title: 'Crockery'
    }
]

export const trendingProductList = [
    {
        id: 1,
        image: '6.png',
        badge: 'Hot',
        badgeColor: 'primary',
        product: "Men's Green Jacket",
        price: '24.00',
        deletePrice: '30.00'
    },
    {
        id: 2,
        image: '5.png',
        product: "Full Sleeve Women Top",
        price: '20.00',
        deletePrice: '25.00'
    },
    {
        id: 3,
        image: '4.png',
        badge: '50%',
        badgeColor: 'secondary',
        product: "Women's Yellow top",
        price: '25.00',
        deletePrice: '35.00'
    }
]

export const openInvoicesData = [
    {
        id: 1,
        invoice: 'FV 00012/05/2024',
        image: '16.png',
        name: 'Walter Reuter',
        email: 'walter.reuter@gmail.com',
        status: 'Paid',
        amount: '5,654.00',
        color: 'primary'
    },
    {
        id: 2,
        invoice: 'FV 00009/10/2024',
        image: '17.png',
        name: 'Selena Waner',
        email: 'selena.waner@gmail.com',
        status: 'Overdue',
        amount: '2,942.00',
        color: 'secondary'
    },
    {
        id: 3,
        invoice: 'FV 00025/04/2024',
        image: '18.png',
        name: 'Fran Loain',
        email: 'fran.loain@gmail.com',
        status: 'Unpaid',
        amount: '3,753.00',
        color: 'warning'
    },
    {
        id: 4,
        invoice: 'FV 00002/11/2024',
        image: '19.png',
        name: 'Wilson Smith',
        email: 'wilson.smith@gmail.com',
        status: 'Paid',
        amount: '5,365.00',
        color: 'info'
    }
]